import { lazy, Suspense, type PropsWithChildren } from 'react';

type RecruiterListContainerProps = {
  isEmpty: boolean;
};

export const RecruiterListContainer = ({
  children,
  isEmpty,
}: PropsWithChildren<RecruiterListContainerProps>) => {
  if (isEmpty) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-3">
        <Suspense>
          <EmptyRecruiterTab />
        </Suspense>
      </div>
    );
  }
  return <div className="flex flex-col gap-4">{children}</div>;
};

const EmptyRecruiterTab = lazy(() =>
  import('@components/jobDetails/recruiter/EmptyRecruiterTab').then((r) => ({
    default: r.EmptyRecruiterTab,
  })),
);
